module.exports = __webpack_public_path__ + "static/media/200-south-africa.871c3d67.svg";